"use client";
import { Toaster as SonnerToaster, toast } from "sonner";
import { useLocale } from "next-intl";

/**
 * Toaster global Sahha — à placer une fois dans le root layout.
 * Respecte la direction RTL en arabe et les tokens de couleur.
 */
export function Toaster() {
  const locale = useLocale();
  const isRtl = locale === "ar";
  return (
    <SonnerToaster
      position={isRtl ? "top-left" : "top-right"}
      dir={isRtl ? "rtl" : "ltr"}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "rounded-xl border-[var(--sahha-border-default)] bg-white shadow-[var(--sahha-shadow-lg)]",
          title: "text-[var(--sahha-text-900)] font-medium",
          description: "text-[var(--sahha-text-600)]",
          success: "border-emerald-200",
          error: "border-red-200",
          warning: "border-amber-200",
        },
      }}
    />
  );
}

export { toast };
